import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ClientIncidentsModule = lazy(loadModule);

export default ClientIncidentsModule;
